export default "__VITE_ASSET__CMEFuIfF__"